import React, { useEffect, useState } from 'react'
import {
    DashboardOutlined,
    UsergroupAddOutlined,
    QuestionCircleOutlined,
    QuestionOutlined,
    SettingOutlined,
    UserOutlined,
    FileOutlined,
    ApartmentOutlined,
    FileSearchOutlined
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import SidebarFooter from './SidebarFooter';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { useBasePath } from '../../hooks/useBasePath';
import SvgIcon from '../../const/SvgIcon';
import { ShowMenu } from '../../utils';
const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
    const navigate = useNavigate();
    const { openKey, selectKey } = useBasePath();

    return (
        <Sider
            className='layout_sidebar'
            collapsible
            collapsed={collapsed}
            width={240}
            trigger={!collapsed ? <SidebarFooter /> : null}
        >
            <Logo collapsed={collapsed} />
            <div className='sidebar_menus'>
                <Menu
                    mode="inline"
                    selectedKeys={selectKey}
                    defaultOpenKeys={openKey}
                    className='menu-side'
                    style={{ background: '#20405f',color:'#fff' }}
                    items={[
                        // {
                        //     key: 'dashboard',
                        //     icon: < DashboardOutlined />,
                        //     label: 'Dashboard Management',
                        //     onClick: () => {
                        //         navigate("/")
                        //     }
                        // },
                        {
                            key: 'hip',
                            icon: <FileOutlined />,
                            label: 'HIP Dashboard',
                            style: { display: ShowMenu(["HIP Dashboard"]) },
                            onClick: () => {
                                navigate("/hip-dashboard")
                            }
                        },
                        {
                            key: 'HIU Dashboard',
                            icon: <FileOutlined />,
                            label: 'HIU Dashboard',
                            style: { display: ShowMenu(["HIU Dashboard"]) },
                            onClick: () => {
                                navigate("/hiu-dashboard")
                            }
                        },
                        // {
                        //     key: 'ticket-management',
                        //     icon: <FileOutlined />,
                        //     label: 'Ticket Management',
                        //     style: { display: ShowMenu(["Ticket Management"]) },
                        //     onClick: () => {
                        //         navigate("/ticket-management")
                        //     }
                        // },
                       
                        {
                            key: 'user-management',
                            icon: < UsergroupAddOutlined />,
                            label: 'Users Management',
                            style: { display: ShowMenu(["Users", "Roles"]) },
                            children: [
                                {
                                    key: 'users',
                                    label: 'Users',
                                    icon: <UserOutlined />,
                                    style: { display: ShowMenu(["Users"]) },
                                    onClick: () => {
                                        navigate("/users")
                                    },
                                },
                                {
                                    key: 'roles',
                                    label: 'Roles',
                                    icon: <UserOutlined />,
                                    style: { display: ShowMenu(["Roles"]) },
                                    onClick: () => {
                                        navigate("/roles")
                                    },
                                }
                            ]
                        },
                    ]}
                />
            </div>
        </Sider>
    )
}

export default Sidebar